export const initialState = {
  guidances: []
};
